import { Card, Empty } from 'antd';
import type { DashboardWidget } from '@/api/dashboardApi';

interface FunnelStage {
  label: string;
  value: number;
  count: number;
}

interface FunnelWidgetProps {
  widget: DashboardWidget;
  data?: FunnelStage[];
  loading?: boolean;
}

export default function FunnelWidget({ widget, data, loading }: FunnelWidgetProps) {
  if (!data || data.length === 0) {
    return (
      <Card title={widget.title} size="small" loading={loading} style={{ height: '100%' }}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </Card>
    );
  }

  const maxVal = Math.max(...data.map((d) => d.value), 1);

  return (
    <Card title={widget.title} size="small" loading={loading} style={{ height: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {data.map((stage, i) => {
          const widthPct = Math.max((stage.value / maxVal) * 100, 20);
          const opacity = 1 - i * 0.12;
          return (
            <div key={stage.label} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div
                style={{
                  width: `${widthPct}%`,
                  height: 32,
                  background: `rgba(24, 144, 255, ${opacity})`,
                  borderRadius: 4,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontSize: 12,
                  fontWeight: 500,
                  margin: '0 auto',
                  minWidth: 80,
                }}
              >
                {stage.label}
              </div>
              <span style={{ fontSize: 12, color: '#8c8c8c', whiteSpace: 'nowrap' }}>
                {stage.count} ({stage.value.toLocaleString()})
              </span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
